import { ColumnsType } from 'antd/es/table';

export type WorkaroundDefinedType =
  | 'NO_WORKAROUND'
  | 'INFINITE'
  | 'DEFINED_TIME';

export const WorkaroundDefinedTypeEnum = {
  NO_WORKAROUND: 'NO_WORKAROUND' as WorkaroundDefinedType,
  INFINITE: 'INFINITE' as WorkaroundDefinedType,
  DEFINED_TIME: 'DEFINED_TIME' as WorkaroundDefinedType,
};

export type EditableColumnType = ColumnsType<any>[number] & {
  editable?: boolean;
  type?: 'number' | 'text' | 'money' | 'percentage' | 'textarea';
  options?: Array<{ value: any; label: string }>;
  suffix?: string;
};
